import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import { closeDetailsEvent } from '../utils/analytics';

export default class IncentiveModal extends React.Component {
	constructor(props) {
		super(props);
		this.close = this.close.bind(this);
	}

	close() {
		const { windowId, widgetName } = this.props.widgetInfo;
		closeDetailsEvent(widgetName, windowId);
		this.props.setModalStateData({}, false);
	}

	render() {
		const { isModalVisible } = this.props;
		const {
			error,
			disclaimer,
			conditional,
			title,
			offerDetails,
			effectiveDate,
			expirationDate
		} = this.props.incentive;

		let dialogTitle;
		let dialogBody;
		if (error) {
			dialogTitle = 'Error: unable to render incentive data';
			dialogBody = <p>{error}</p>;
		} else {
			dialogTitle = (
				<Common
					render={({ labels }) => {
						return (
							<span className="h3 font-weight-bold">
								{labels.get('VEHICLE_INCENTIVE')}
							</span>
						);
					}}
				/>
			);

			let incentiveDisclaimer = '';
			if (disclaimer) {
				incentiveDisclaimer = (
					<Common
						render={({ labels }) => {
							return (
								<div className="text-muted mt-4">
									<h4>{labels.get('DISCLAIMER')}</h4>
									<p>{disclaimer}</p>
								</div>
							);
						}}
					/>
				);
			}

			dialogBody = (
				<Common
					render={({ labels }) => {
						let offer;
						if (conditional) {
							offer = labels.getHTML('DEALER_OFFER');
						} else {
							offer = labels.getHTML('MANUFACTURER_OFFER');
						}
						return (
							<div>
								<h4 className="text-muted mt-2 mb-0">
									{offer}
								</h4>
								<h2 className="mt-0">{title}</h2>
								<p>
									<span className="d-block">
										{offerDetails}
									</span>
									<span className="d-block">
										{labels.get('OFFER_VALID')}{' '}
										{effectiveDate} {labels.get('THROUGH')}{' '}
										{expirationDate}
									</span>
								</p>
								{incentiveDisclaimer}
							</div>
						);
					}}
				/>
			);
		}
		return (
			<div>
				<Modal show={isModalVisible} onHide={this.close}>
					<div className="m-1">
						<Modal.Header closeButton>
							<Modal.Title className="text-center">
								{dialogTitle}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>{dialogBody}</Modal.Body>
					</div>
				</Modal>
			</div>
		);
	}
}

IncentiveModal.propTypes = {
	incentive: PropTypes.shape({
		key: PropTypes.string,
		title: PropTypes.string,
		label: PropTypes.string,
		offerDetails: PropTypes.string,
		shortTitle: PropTypes.string,
		disclaimer: PropTypes.string,
		effectiveDate: PropTypes.string,
		expirationDate: PropTypes.string,
		conditional: PropTypes.bool,
		error: PropTypes.string
	}).isRequired,
	isModalVisible: PropTypes.bool.isRequired,
	setModalStateData: PropTypes.func.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};



// WEBPACK FOOTER //
// ./src/components/IncentiveModal.jsx